import { useState, useEffect } from 'react';
import {
  getManageEnvelopeList,
  getDocuments,
  showMyFiles,
} from "../../../../services/CommonService";

const useDocumentCounts = ({ userEmail, selectedUserId, dataParams, userId }) => {
  const [counts, setCounts] = useState({
    totalMyFile: 0,
    totalFiles: 0,
    totalInProgress: 0,
    totalDraft: 0,
    totalCompleted: 0,
  });
  const [envelopeList, setEnvelopeList] = useState([]);
  const [envelopeProcess, setEnvelopeProcess] = useState();
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalEnvelopes, setTotalEnvelopes] = useState(0);
  useEffect(() => {
    setEnvelopeList([]);
    setEnvelopeProcess();

    getManageEnvelopeList(dataParams)
      .then((response) => {
        const allData = response?.data?.data || [];

        const filteredData = allData.filter(
          (item) => !item.is_negotiation
        );

        setEnvelopeList(filteredData);

        if (filteredData.length === 0)
          setEnvelopeProcess("No Contracts available");

        // const statusCount = response?.data?.status_count || [];

        const inProgressCount = filteredData.filter(
          (e) => e.status_id === 1
        ).length;
        const draftCount = filteredData.filter(
          (e) => e.status_id === 0
        ).length;
        const completedCount = filteredData.filter(
          (e) => e.status_id === 2
        ).length;

        setCounts((prev) => ({
          ...prev,
          totalInProgress: inProgressCount,
          totalDraft: draftCount,
          totalCompleted: completedCount,
        }));
      })
      .catch(() => {
        setEnvelopeProcess("No data available.");
        setCounts((prev) => ({
          ...prev,
          totalInProgress: 0,
          totalDraft: 0,
          totalCompleted: 0,
        }));
      });
  }, [dataParams, userId]);

  setEnvelopeProcess && (
    <div className="page-loading">
      <img src="/images/loader.gif" alt="loader" />
    </div>
  )

  return {
    counts,
    envelopeList,
    totalEnvelopes,
    envelopeProcess,
    documents,
    loading,
    setLoading,
    setCounts,
    setEnvelopeList,
    setEnvelopeProcess,
    setDocuments
  };
};

export default useDocumentCounts;